import { Product } from '../types';

export const DEMO_PRODUCTS: Product[] = [
  {
    id: 1,
    category: 1,
    category_name: 'Dresses',
    name: 'Ruched Pearl Maxi Dress - Sky Blue',
    slug: 'ruched-pearl-maxi-dress-sky-blue',
    description: 'A stunning off-shoulder ruched maxi dress in sky blue, adorned with a delicate pearl bead strip running down the center. Features braided rope straps and a body-hugging silhouette that flatters every curve. Handcrafted with meticulous attention to detail, this dress is perfect for elegant occasions and evening events.',
    price: '285.00',
    discount_price: null,
    image: '/images/IMG_1370.jpg',
    image_2: '/images/IMG_1376.jpg',
    image_3: '/images/IMG_1373.jpg',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Sky Blue'],
    in_stock: true,
    featured: true,
    created_at: '2026-03-01',
  },
  {
    id: 2,
    category: 1,
    category_name: 'Dresses',
    name: 'Ruched Beaded Maxi Dress - Black',
    slug: 'ruched-beaded-maxi-dress-black',
    description: 'An elegant off-shoulder ruched maxi dress in classic black, featuring a striking gold bead strip down the center and braided rope straps. The ruched detailing creates a sculpted look while the gold accents add a touch of luxury. A statement piece for any sophisticated wardrobe.',
    price: '285.00',
    discount_price: null,
    image: '/images/IMG_1425.jpg',
    image_2: '/images/IMG_1427.jpg',
    image_3: '/images/IMG_1378.jpg',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Black'],
    in_stock: true,
    featured: true,
    created_at: '2026-03-01',
  },
  {
    id: 3,
    category: 1,
    category_name: 'Dresses',
    name: 'Beaded Fringe Halter Dress - Red',
    slug: 'beaded-fringe-halter-dress-red',
    description: 'A bold halter-neck dress in vibrant red with gold bead accents along the neckline. Features dramatic beaded fringe detailing from mid-thigh, creating stunning movement with every step. The fitted bodice and high neckline give a sleek silhouette while the fringe adds playful drama.',
    price: '320.00',
    discount_price: null,
    image: '/images/IMG_1416.jpg',
    image_2: '/images/IMG_1382.jpg',
    image_3: '/images/IMG_1419.jpg',
    sizes: ['S', 'M', 'L'],
    colors: ['Red'],
    in_stock: true,
    featured: true,
    created_at: '2026-03-05',
  },
  {
    id: 4,
    category: 1,
    category_name: 'Dresses',
    name: 'Beaded Fringe Halter Dress - Black',
    slug: 'beaded-fringe-halter-dress-black',
    description: 'A show-stopping halter-neck dress in sleek black, embellished with gold beads along the neckline and throughout the fringe. The beaded fringe cascades from mid-thigh, creating a mesmerizing effect. A perfect fusion of edgy and glamorous for nights that demand attention.',
    price: '320.00',
    discount_price: null,
    image: '/images/IMG_1421.jpg',
    image_2: '/images/IMG_1422.jpg',
    image_3: '/images/IMG_1420.jpg',
    sizes: ['S', 'M', 'L'],
    colors: ['Black'],
    in_stock: true,
    featured: true,
    created_at: '2026-03-05',
  },
  {
    id: 5,
    category: 2,
    category_name: 'Sets',
    name: 'Pink Plaid Two-Piece Set',
    slug: 'pink-plaid-two-piece-set',
    description: 'A chic matching set featuring a strapless bandeau crop top and wide-leg palazzo pants in a vibrant pink plaid print. The relaxed fit and bold pattern make this the ultimate statement set for brunches, vacations, and summer outings. Comfortable yet effortlessly stylish.',
    price: '195.00',
    discount_price: null,
    image: '/images/IMG_1388.jpg',
    image_2: '/images/IMG_1386.jpg',
    image_3: '/images/IMG_1391.jpg',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Pink'],
    in_stock: true,
    featured: true,
    created_at: '2026-03-10',
  },
  {
    id: 6,
    category: 3,
    category_name: 'Gowns',
    name: 'Draped Cape Gown - Red',
    slug: 'draped-cape-gown-red',
    description: 'A breathtaking floor-length gown in rich red with dramatic cape sleeves that create an ethereal silhouette. Features a cowl neckline adorned with gold bead detailing. The flowing fabric drapes beautifully, making a grand entrance at any formal event. A true masterpiece of design.',
    price: '450.00',
    discount_price: null,
    image: '/images/IMG_1396.jpg',
    image_2: '/images/IMG_1397.jpg',
    image_3: '/images/IMG_1393.jpg',
    sizes: ['S', 'M', 'L'],
    colors: ['Red'],
    in_stock: true,
    featured: true,
    created_at: '2026-03-15',
  },
  {
    id: 7,
    category: 3,
    category_name: 'Gowns',
    name: 'Draped Cape Gown - Sky Blue',
    slug: 'draped-cape-gown-sky-blue',
    description: 'An enchanting floor-length cape gown in sky blue with a cowl neckline accented by pearl bead detailing. The sweeping cape sleeves and fluid drape create a regal, goddess-like presence. Crafted for women who command attention with grace and elegance.',
    price: '450.00',
    discount_price: null,
    image: '/images/IMG_1392.jpg',
    image_2: '/images/IMG_1393.jpg',
    image_3: '',
    sizes: ['S', 'M', 'L'],
    colors: ['Sky Blue'],
    in_stock: true,
    featured: false,
    created_at: '2026-03-15',
  },
  {
    id: 8,
    category: 3,
    category_name: 'Gowns',
    name: 'Heart Detail Ruched Gown - Red',
    slug: 'heart-detail-ruched-gown-red',
    description: 'A romantic floor-length gown in vibrant red featuring an exquisite heart motif on the bodice created with intricate ruching and bead work. The high neckline and sleeveless design offer a modern elegance, while the flowing skirt ensures graceful movement. A truly unique piece for unforgettable moments.',
    price: '380.00',
    discount_price: null,
    image: '/images/IMG_1394.jpg',
    image_2: '/images/IMG_1395.jpg',
    image_3: '',
    sizes: ['S', 'M', 'L'],
    colors: ['Red'],
    in_stock: true,
    featured: false,
    created_at: '2026-03-18',
  },
];

export const getFeaturedProducts = () => DEMO_PRODUCTS.filter(p => p.featured);

export const getProductBySlug = (slug: string) => DEMO_PRODUCTS.find(p => p.slug === slug);

export const getProductsByCategory = (category: string) =>
  category
    ? DEMO_PRODUCTS.filter(p => p.category_name.toLowerCase() === category.toLowerCase())
    : DEMO_PRODUCTS;
